export const endpoints = {
  CONVERT_CV: "https://api.beta.limited/pdf/convert",
  SHAPE_CONTENT: "https://linkedin-cv-crawler.beta-limited.workers.dev/extract-data-from-cv",
  EVALUATE_CV: "https://linkedin-cv-crawler.beta-limited.workers.dev/evaluatecv",
};
